import React, { useState } from 'react';
import './customTagList.scss';
import { IonIcon } from '@ionic/react';
import { shieldOutline, peopleCircle } from 'ionicons/icons';


export interface TagListProps {
    items: string[];
    type: 'specialization' | 'team' ;
    maxVisibleItems?: number;
    showIcon?: boolean;
    className?: string;
    size?: 'small' | 'medium' | 'large';
    expandable?: boolean;
}

export const TagList: React.FC<TagListProps> = ({ items = [], type = 'specialization', maxVisibleItems = 2, showIcon = true, className = '', size = 'small', expandable = true }) => {
    const [showAll, setShowAll] = useState(false);
    const isEmpty = items?.length === 0 || (items?.length === 1 && (items[0] === null || items[0] === ''));
    if (type === 'team' && isEmpty) return null;

    const visibleItems = expandable && !showAll ? items.slice(0, maxVisibleItems) : items;
    const hasMore = expandable && items.length > maxVisibleItems;
    const remainingCount = items.length - maxVisibleItems;


    const getIconClass = () => {
        switch (type) {
            case 'specialization':
                return shieldOutline;
            case 'team':
                return peopleCircle;
            default:
                return peopleCircle;
        }
    };

    const getTypeClass = () => {
        switch (type) {
            case 'specialization':
                return 'specializations';
            case 'team':
                return 'teams';
            default:
                return 'default-tags';
        }
    };

    return (
        <div className={`tag-list-container ${getTypeClass()} ${size} ${className}`}>
            {showIcon && (
                <div className="tag-icon">
                    <IonIcon icon={getIconClass()}/>
                </div>
            )}

            <div className="tag-list">

                {isEmpty && type === 'specialization' ? (
                    <span className="tag no-tag">No Speciality</span>
                ) : (
                    <>
                        {visibleItems?.map((item, index) => (
                            <span key={index} className="tag" title={item}>
                                {item}
                            </span>
                        ))}
                    </>)}

                {hasMore && !showAll && (
                    <button
                        className="expand-btn"
                        onClick={() => setShowAll(true)}
                        aria-label={`Show ${remainingCount} more ${type}s`}
                        title={`Show ${remainingCount} more items`}
                    >
                        +{remainingCount}
                    </button>
                )}

                {hasMore && showAll && items?.length > maxVisibleItems && (
                    <button
                        className="collapse-btn"
                        onClick={() => setShowAll(false)}
                        aria-label={`Show less ${type}s`}
                        title="Show less items"
                    >
                        Show less <i className="fa fa-chevron-up" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        </div>
    );
};

export default TagList;